import { render, staticRenderFns } from "./SettingsNotificationMailingDisabledAttachments.vue?vue&type=template&id=6f76ee34&"
import script from "./SettingsNotificationMailingDisabledAttachments.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationMailingDisabledAttachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports